import { render } from "./KpiQuestionAssignment.vue?vue&type=template&id=1b5d1242&scoped=true"
import script from "./KpiQuestionAssignment.vue?vue&type=script&lang=js"
export * from "./KpiQuestionAssignment.vue?vue&type=script&lang=js"

import "./KpiQuestionAssignment.vue?vue&type=style&index=0&id=1b5d1242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5d1242"]])

export default __exports__